<template>
   <div class="admin-top-wrapper">
      <nav-header :region-select="false"/>
      <div class="main-container">
         <div class='pseudo-sidebar-before'/>
         <div class="sidebar-wrapper">
            <sidebar/>
         </div>
         <div class="main">
            <router-view/>
         </div>
      </div>
      <org-footer/>
   </div>
</template>

<script>
import { fetchWithAuthToken } from '@/axios';
import NavHeader from "../../organisms/Home/Header";
import Sidebar from "../../organisms/Admin/Sidebar";
import Footer from "../../organisms/Home/Footer";

export default {
   name: 'admin',
   components: {
      NavHeader,
      Sidebar,
      "org-footer": Footer,
  },
  created() {
     fetchWithAuthToken("/api/check-logged-in/", {logOutIfFail: true});
  },
};
</script>

<style lang="scss">
.el-table th, .el-table tr {
   background-color: transparent;
}
.admin-top-wrapper {
   display: grid;
   // max-height: 1000px;
   min-height: 100vh;
   grid-template-rows: auto minmax(0, 1fr) auto;

   .main-container {
      display: grid;
      grid-template-columns: minmax(230px, 20%) 1fr;
      position: relative;

      .sidebar-wrapper {
         position: absolute;
         top: 0;
         bottom: 0;
         width: 20%;
         min-width: 230px;
         background: whitesmoke;
      }
      .pseudo-sidebar-before {
         z-index: -1;
      }

      .dashboard-tool-wrapper {
         min-height: 0;
         height: 100%;
         padding: 5px;
         overflow: auto;
      }
      .main {
         background: #dfdfdf;
         table {
            background: transparent;
         }
      };
   }
}
</style>
